/* eslint-disable import/prefer-default-export */
/* eslint-disable react/prop-types */
import React from 'react';
import { PropTypes } from 'prop-types';
import { useLocalizedFromContext } from 'data/Localization';

export const GradientCrop14 = ({ title, ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="47.142"
    height="88.456"
    viewBox="0 0 47.142 88.456"
    {...props}
  >
    <title>{useLocalizedFromContext(title)}</title>
    <defs>
      <clipPath id="clip-path14">
        <path
          id="Path_220"
          dataname="Path 220"
          d="M59.1.575a1.5,1.5,0,0,0-2.681.946A5.79,5.79,0,0,1,52.78,6.557c-3.029,1.382-6.488,4.144-7.112,7.748a6.6,6.6,0,0,0,.709,4.216,8.1,8.1,0,0,0-6.488,4.464,8.006,8.006,0,0,0,.966,7.69A8.063,8.063,0,0,0,34.5,35.12a7.985,7.985,0,0,0,.923,7.629,8.044,8.044,0,0,0-6.275,4.426,7.985,7.985,0,0,0,.919,7.623,7.5,7.5,0,0,0-5.23,12.22,6.6,6.6,0,0,0-3.5,2.273c-2.254,2.879-1.982,7.3-.975,10.47a5.794,5.794,0,0,1-1.287,6.066,1.5,1.5,0,0,0,.979,2.635c.036,0,.071,0,.107,0,1.479-.105,14.542-1.218,17.726-7.973,1.043-2.212.889-4.691-.427-7.39,3.4-.254,6.173-1.909,7.343-4.546a7.984,7.984,0,0,0-.92-7.636,8.047,8.047,0,0,0,6.27-4.415,7.99,7.99,0,0,0-.922-7.64,8.049,8.049,0,0,0,6.274-4.416,8.013,8.013,0,0,0-.976-7.7,8.072,8.072,0,0,0,6.363-4.431c1.193-2.687.566-5.87-1.608-8.595,2.9-.836,4.858-2.391,5.8-4.665C67.931,12.156,60.01,1.74,59.1.575ZM62.31,17.9c-.761,1.839-2.8,2.974-6.054,3.374a1.5,1.5,0,0,0-1.307,1.672,1.48,1.48,0,0,0,.774,1.11,1.473,1.473,0,0,0,.356.58c2.13,2.059,2.923,4.531,2.07,6.453-.88,1.983-3.428,3.068-6.5,2.765a1.514,1.514,0,0,0-1.64,1.346,1.487,1.487,0,0,0,.414,1.179,1.472,1.472,0,0,0,.269.392c2.13,2.059,2.923,4.532,2.071,6.453-.881,1.983-3.433,3.07-6.5,2.765a1.514,1.514,0,0,0-1.641,1.345,1.5,1.5,0,0,0,.636,1.371,1.466,1.466,0,0,0,.084.122c2.13,2.059,2.923,4.531,2.07,6.453-.881,1.984-3.433,3.07-6.5,2.764a1.512,1.512,0,0,0-1.64,1.346,1.493,1.493,0,0,0,.643,1.376c.031.036.044.08.078.113,2.13,2.058,2.923,4.53,2.07,6.452-.88,1.983-3.429,3.072-6.5,2.765a1.41,1.41,0,0,0-.268,0,1.5,1.5,0,0,0-1.749,2.274c1.936,2.717,2.484,5.016,1.63,6.832-1.6,3.406-7.761,5.143-12.09,5.869a8.984,8.984,0,0,0,.138-6.22c-.8-2.517-.96-5.879.477-7.716a4.356,4.356,0,0,1,4.025-1.421A1.5,1.5,0,0,0,28.681,67a1.222,1.222,0,0,0-.072-.105c-2.127-2.059-2.919-4.529-2.066-6.45.882-1.988,3.446-3.075,6.517-2.765a1.5,1.5,0,0,0,.964-2.744c-.026-.029-.036-.066-.064-.093-2.128-2.057-2.92-4.529-2.067-6.45.881-1.988,3.442-3.076,6.517-2.764a1.5,1.5,0,0,0,.971-2.74,1.2,1.2,0,0,0-.069-.1c-2.128-2.058-2.92-4.53-2.068-6.45.884-1.988,3.444-3.075,6.518-2.764a1.5,1.5,0,0,0,1.162-2.594,1.438,1.438,0,0,0-.226-.327c-2.127-2.058-2.92-4.529-2.067-6.45.884-1.988,3.444-3.072,6.517-2.764A1.509,1.509,0,0,0,50.791,20.1a1.492,1.492,0,0,0-.415-1.185,1.5,1.5,0,0,0-.107-.157c-1.34-1.3-1.878-2.59-1.645-3.938.4-2.3,3-4.434,5.4-5.53A8.989,8.989,0,0,0,58.549,5.01C60.911,8.7,63.749,14.418,62.31,17.9ZM39.32,66.2a1.5,1.5,0,0,1-1.248,1.714,12.559,12.559,0,0,1-1.972.163c-5.151,0-6.622-3.632-6.689-3.805A1.5,1.5,0,0,1,32.2,63.17c.119.27,1.222,2.446,5.406,1.786A1.5,1.5,0,0,1,39.32,66.2Zm5.33-12.025A1.5,1.5,0,0,1,43.4,55.894a12.672,12.672,0,0,1-1.972.162c-5.151,0-6.622-3.632-6.689-3.805a1.5,1.5,0,0,1,2.788-1.1c.119.271,1.222,2.443,5.407,1.785A1.5,1.5,0,0,1,44.65,54.179Zm5.33-12.024a1.5,1.5,0,0,1-1.248,1.715,12.663,12.663,0,0,1-1.972.162c-5.152,0-6.622-3.633-6.689-3.805a1.5,1.5,0,0,1,2.788-1.106c.12.27,1.222,2.446,5.407,1.785A1.5,1.5,0,0,1,49.98,42.155ZM55.311,30.13a1.5,1.5,0,0,1-1.248,1.716,12.684,12.684,0,0,1-1.973.162c-5.152,0-6.622-3.633-6.689-3.805A1.5,1.5,0,0,1,48.189,27.1c.12.27,1.211,2.445,5.407,1.785A1.5,1.5,0,0,1,55.311,30.13Z"
          fill="none"
        />
      </clipPath>
    </defs>
    <g id="Group_96" dataname="Group 96" transform="translate(-18.555 -0.006)">
      <g id="Group_95" dataname="Group 95" clipPath="url(#clip-path14)">
        <g id="Group_94" dataname="Group 94">
          <path
            id="Path_217"
            dataname="Path 217"
            d="M84.25,88.462V53.44L.068,73.159v15.3Z"
            fill="#5f9501"
          />
          <path
            id="Path_218"
            dataname="Path 218"
            d="M.068,34.492V73.159L84.25,53.44V14.774Z"
            fill="#79b61d"
          />
          <path
            id="Path_219"
            dataname="Path 219"
            d="M.068.006V34.492L84.25,14.774V.006Z"
            fill="#c8d200"
          />
        </g>
      </g>
    </g>
  </svg>
);

GradientCrop14.defaultProps = {
  title: 'protein_peas',
};

GradientCrop14.propTypes = {
  className: PropTypes.string,
  title: PropTypes.string,
};
